import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

import type { UserActions, UserState } from '@/types/userStore.types'

import { createSelectors } from '@/store/helpers.store'

const initializeState: UserState = {
  currentRole: null,
  isInitialized: false,
  user: null,
}

const useUserStoreBase = create(
  immer<UserState & UserActions>(set => ({
    resetUser: () =>
      set(draft => {
        draft.user = null
      }),
    setCurrentRole: role => {
      set(draft => {
        draft.currentRole = role
      })
    },
    setIsInitialized: isInitialized => {
      set(draft => {
        draft.isInitialized = isInitialized
      })
    },
    setUser: user => {
      set(draft => {
        draft.user = user
      })
    },
    ...initializeState,
  })),
)

export const useUserStore = createSelectors(useUserStoreBase)
